import Loadable from 'react-loadable';
import type { RouteContext } from 'react-resource-router';

const Explore = Loadable<RouteContext, any>({
  loader: () => import(/* webpackChunkName: "explore" */ './Explore'),
  loading: () => null,
});

export default Explore;
